import PropTypes from 'prop-types';
import React from 'react';

import { colors } from '../../../common/styles/style-constants';

const FreshBreath = ({ color }) => (
  <svg width="14" height="15" xmlns="http://www.w3.org/2000/svg">
    <g fill={color} fillRule="evenodd">
      <path d="M10.896.003a2.67 2.67 0 0 0-2.668 2.666.672.672 0 0 0 1.343 0 1.322 1.322 0 1 1 1.323 1.323H.672a.671.671 0 1 0 0 1.344h10.383a.702.702 0 0 0 .16-.02A2.667 2.667 0 0 0 10.894 0v.003zM12.622 8.163a.672.672 0 0 0 0-1.343H1.807a.672.672 0 0 0 0 1.343h10.815zM11.214 9.636a.702.702 0 0 0-.159-.02H.672a.672.672 0 0 0 0 1.343h10.224a1.324 1.324 0 1 1-1.323 1.323.672.672 0 0 0-1.344 0 2.667 2.667 0 1 0 2.985-2.647z" />
    </g>
  </svg>
);

FreshBreath.defaultProps = {
  color: colors.blue,
};

FreshBreath.propTypes = {
  color: PropTypes.string,
};

export default FreshBreath;
